// extracted by mini-css-extract-plugin
export default {"modal":"SelectCilentAccount_modal__tr27y","tips":"SelectCilentAccount_tips__Z8OFQ"};